"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = refreshDirectLineToken;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _fetchJSON = _interopRequireDefault(require("./fetchJSON"));

// Refreshes the given token
function refreshDirectLineToken(_x) {
  return _refreshDirectLineToken.apply(this, arguments);
}

function _refreshDirectLineToken() {
  _refreshDirectLineToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(token) {
    var _yield$fetchJSON, refreshedToken;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _fetchJSON.default)('https://directline.botframework.com/v3/directline/tokens/refresh', {
              headers: {
                authorization: "Bearer ".concat(token)
              },
              method: 'POST'
            });

          case 2:
            _yield$fetchJSON = _context.sent;
            refreshedToken = _yield$fetchJSON.token;
            return _context.abrupt("return", refreshedToken);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _refreshDirectLineToken.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9yZWZyZXNoRGlyZWN0TGluZVRva2VuLmpzIl0sIm5hbWVzIjpbInJlZnJlc2hEaXJlY3RMaW5lVG9rZW4iLCJ0b2tlbiIsImhlYWRlcnMiLCJhdXRob3JpemF0aW9uIiwibWV0aG9kIiwicmVmcmVzaGVkVG9rZW4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFFQTtTQUM4QkEsc0I7Ozs7O29HQUFmLGlCQUFzQ0MsS0FBdEM7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsbUJBQzJCLHdCQUFVLGtFQUFWLEVBQThFO0FBQ3BIQyxjQUFBQSxPQUFPLEVBQUU7QUFDUEMsZ0JBQUFBLGFBQWEsbUJBQVlGLEtBQVo7QUFETixlQUQyRztBQUlwSEcsY0FBQUEsTUFBTSxFQUFFO0FBSjRHLGFBQTlFLENBRDNCOztBQUFBO0FBQUE7QUFDRUMsWUFBQUEsY0FERixvQkFDTEosS0FESztBQUFBLDZDQVFOSSxjQVJNOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLEciLCJzb3VyY2VSb290IjoiZGlyZWN0bGluZXNwZWVjaDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgZmV0Y2hKU09OIGZyb20gJy4vZmV0Y2hKU09OJztcblxuLy8gUmVmcmVzaGVzIHRoZSBnaXZlbiB0b2tlblxuZXhwb3J0IGRlZmF1bHQgYXN5bmMgZnVuY3Rpb24gcmVmcmVzaERpcmVjdExpbmVUb2tlbih0b2tlbikge1xuICBjb25zdCB7IHRva2VuOiByZWZyZXNoZWRUb2tlbiB9ID0gYXdhaXQgZmV0Y2hKU09OKCdodHRwczovL2RpcmVjdGxpbmUuYm90ZnJhbWV3b3JrLmNvbS92My9kaXJlY3RsaW5lL3Rva2Vucy9yZWZyZXNoJywge1xuICAgIGhlYWRlcnM6IHtcbiAgICAgIGF1dGhvcml6YXRpb246IGBCZWFyZXIgJHt0b2tlbn1gXG4gICAgfSxcbiAgICBtZXRob2Q6ICdQT1NUJ1xuICB9KTtcblxuICByZXR1cm4gcmVmcmVzaGVkVG9rZW47XG59XG4iXX0=